import { flowUtils } from '@atlassian/mpac-utils';
export function foldMarketplaceProduct(marketplaceProduct) {
  return function (jira, confluence, compass) {
    switch (marketplaceProduct) {
      case 'jira':
        return jira();
      case 'confluence':
        return confluence();
      case 'compass':
        return compass();
      default:
        throw flowUtils.unexpectedCase(marketplaceProduct);
    }
  };
}